import React from 'react';
import * as R from 'ramda';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import { compose } from 'react-recompose';
// features
import { CostsSection, validationSchemaCostsObject } from '../../../work-order/components/costs-section';
// components
import { ChargeFormFooter } from '../../../../components/form-footer';
// forms
import { Fieldset2 } from '../../../../forms';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// ui
import { Box, scrollableContainerCss4px } from '../../../../ui';
//////////////////////////////////////////////////

const validationSchema = Yup.object()
  .shape(validationSchemaCostsObject)
  .shape({
    [GC.FIELD_DATE]: G.yupStringNotRequired,
    [GC.FIELD_CURRENCY]: G.yupStringRequired,
    [GC.FIELD_SERVICE_VENDOR_GUID]: G.yupStringRequired,
    [GC.FIELD_NUMBER]: G.yupStringNotRequired.max(40, G.getShouldBeFromToLocaleTxt(0, 40)),
    [GC.FIELD_DESCRIPTION]: G.yupStringNotRequired.max(2000, G.getShouldBeFromToLocaleTxt(0, 2000)),
  });

const inputWrapperStyles = { mb: 30, width: 170 };

const fieldSettings = [
  {
    isRequired: true,
    type: 'reactSelect',
    fieldName: GC.FIELD_SERVICE_VENDOR_GUID,
    inputWrapperStyles: { mb: 30, width: 200 },
    options: 'serviceVendorListAvailableOptions',
    label: ['titles:service-vendor', 'Service Vendor'],
  },
  {
    type: 'text',
    inputWrapperStyles,
    fieldName: GC.FIELD_NUMBER,
    label: ['titles:number', 'Number'],
  },
  {
    isClearable: true,
    type: 'datePicker',
    inputWrapperStyles,
    fieldName: GC.FIELD_DATE,
    label: ['titles:date', 'Date'],
  },
  {
    type: 'select',
    isRequired: true,
    inputWrapperStyles,
    fieldName: GC.FIELD_CURRENCY,
    options: GC.CURRENCY_OPTIONS,
    label: ['titles:currency', 'Currency'],
  },
  {
    type: 'textarea',
    fieldName: GC.FIELD_DESCRIPTION,
    label: ['titles:description', 'Description'],
    inputWrapperStyles: { mb: 20, width: '100%' },
  },
];

const defaultValues = {
  [GC.FIELD_DATE]: null,
  [GC.FIELD_NUMBER]: null,
  [GC.FIELD_DESCRIPTION]: null,
  [GC.FIELD_SERVICE_VENDOR_GUID]: null,
  [GC.FIELD_CURRENCY]: R.or(
    G.getAmousConfigByNameFromWindow(GC.GENERAL_BRANCH_DEFAULT_CURRENCY),
    GC.DEFAULT_UI_CURRENCY,
  ),
};

const enhance = compose(
  withFormik({
    validationSchema,
    handleSubmit: (values, { props: { submitAction } }) => submitAction(values),
    mapPropsToValues: ({ initialValues }) => G.setInitialFormikValues(defaultValues, initialValues),
  }),
);

const fieldsWrapperStyles = { px: 15, justifyContent: 'space-between' };

const EstimateForm = enhance((props) => {
  const { handleSubmit, serviceVendorListAvailableOptions } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Box overflow='auto' maxHeight='calc(87vh - 50px)' css={scrollableContainerCss4px}>
        <Fieldset2
          {...G.getFormikProps(props)}
          fields={fieldSettings}
          fieldsWrapperStyles={{ ...fieldsWrapperStyles, pt: 25 }}
          serviceVendorListAvailableOptions={serviceVendorListAvailableOptions}
        />
        <CostsSection {...props} />
      </Box>
      <ChargeFormFooter />
    </form>
  );
});

export default EstimateForm;
